import device from 'current-device';
const utils = {
  systemCheck: () => {
    // {mac:'Mac',win:'Win',ios:'iOS',android:'Android',other:'Other'}
    if (device.ios()) {
      //是否IOS
      return 'iOS';
    } else if (device.android()) {
      //是否安卓
      return 'Android';
    } else if (device.desktop()) {
      if (navigator.userAgent.indexOf('Windows') !== -1) {
        return 'Win';
      } else if (navigator.userAgent.indexOf('Mac') !== -1) {
        //是否MAC
        return 'Mac';
      } else {
        return 'Other';
      }
    } else {
      return 'Other';
    }
  },
  /**
   * 将数组乱序的方法
   * @param {Array} array 需要乱序的数组
   * @returns 乱序之后的数组
   */
  shuffle: (array) => {
    for (let i = array.length; i; i--) {
      let j = Math.floor(Math.random() * i);
      [array[i - 1], array[j]] = [array[j], array[i - 1]];
    }
    return array;
  },

  /**
   * 字符串中间省略
   * @param {string} str 需要中间省略的字符串
   * @param {number} preLength 省略号前面的字符串长度
   * @param {number} nextLength 省略号后面的字符串长度
   * @returns 省略之后的字符串
   */
  omissionString: (str, preLength, nextLength) => {
    if (str && str.length > preLength + nextLength) {
      let subStr1 = str.substr(0, preLength);
      let subStr2 = str.substr(str.length - nextLength, nextLength);
      let subStr = subStr1 + '...' + subStr2;
      return subStr;
    }
    return str;
  },

  /**
   * 获取当前语种信息
   * @return {string}  语种缩写
   */
  getLanguage: () => {
    const pathname = window.location.pathname; // path
    const hostname = window.location.hostname; // 域名

    // let hostname='https://hitpaw-dev.afirstsoft.cn/tools/v2/account.html#/purchase'

    // 简体中文语种不存在
    // let isCN=(hostname !== "hitpaw-test.afirstsoft.cn" && /\.cn/.test(hostname)) || (isDEV_NODE_ENV && /(\/cn\/)/.test(pathname))
    let isCN = false;

    const isDEV_NODE_ENV = process.env.NODE_ENV === 'development'; //当前环境是否是 测试环境||本地环境
    let lang = 'en';

    // 正式地址：online.hitpaw.com/ar/... ||  测试地址：hitpaw-test.afirstsoft.cn/ar/...
    if (
      /ar\./.test(hostname) ||
      (isDEV_NODE_ENV && /(\/ar\/)/.test(pathname))
    ) {
      lang = 'ar';
    }
    // tr.hitpaw.com/... ||  测试地址：hitpaw-test.afirstsoft.cn/tr/...
    else if (
      /tr\./.test(hostname) ||
      (isDEV_NODE_ENV && /(\/tr\/)/.test(pathname))
    ) {
      lang = 'tr';
    } // 正式地址：online.hitpaw.fr ||  测试地址：hitpaw-test.afirstsoft.cn/fr/...
    else if (
      /\.fr/.test(hostname) ||
      (isDEV_NODE_ENV && /(\/fr\/)/.test(pathname))
    ) {
      lang = 'fr';
    }
    // 正式地址：online.hitpaw.de ||  测试地址：hitpaw-test.afirstsoft.cn/de/...
    else if (
      /\.de/.test(hostname) ||
      (isDEV_NODE_ENV && /(\/de\/)/.test(pathname))
    ) {
      lang = 'de';
    }
    // 正式地址：online.hitpaw.es ||  测试地址：hitpaw-test.afirstsoft.cn/es/...
    else if (
      /\.es/.test(hostname) ||
      (isDEV_NODE_ENV && /(\/es\/)/.test(pathname))
    ) {
      lang = 'es';
    }
    // 正式地址：online.hitpaw.tr ||  测试地址：hitpaw-test.afirstsoft.cn/tr/...
    else if (
      /\.jp/.test(hostname) ||
      (isDEV_NODE_ENV && /(\/jp\/)/.test(pathname))
    ) {
      lang = 'jp';
    }
    // 正式地址：online.hitpaw.jp ||  测试地址：hitpaw-test.afirstsoft.cn/jp/...
    else if (
      /\.tw/.test(hostname) ||
      (isDEV_NODE_ENV && /(\/tw\/)/.test(pathname))
    ) {
      lang = 'tw';
    }
    // 正式地址：online.hitpaw.it ||  测试地址：hitpaw-test.afirstsoft.cn/it/...
    else if (
      /\.it/.test(hostname) ||
      (isDEV_NODE_ENV && /(\/it\/)/.test(pathname))
    ) {
      lang = 'it';
    }
    // 正式地址：online.hitpaw.com.br ||  测试地址：hitpaw-test.afirstsoft.cn/br/...
    else if (
      /\.br/.test(hostname) ||
      (isDEV_NODE_ENV && /(\/br\/)/.test(pathname))
    ) {
      lang = 'br';
    }
    // 正式地址：online.hitpaw.cn ||  测试地址：hitpaw-test.afirstsoft.cn/cn/...
    else if (isCN) {
      lang = 'cn';
    }
    // 正式地址：online.hitpaw.ru ||  测试地址：hitpaw-test.afirstsoft.cn/ru/...
    else if (
      /\.ru/.test(hostname) ||
      (isDEV_NODE_ENV && /(\/ru\/)/.test(pathname))
    ) {
      lang = 'ru';
    }
    // 正式地址：online.hitpaw.kr ||  测试地址：hitpaw-test.afirstsoft.cn/kr/...
    else if (
      /\.kr/.test(hostname) ||
      (isDEV_NODE_ENV && /(\/kr\/)/.test(pathname))
    ) {
      lang = 'kr';
    }
    // 正式地址：online.hitpaw.in ||  测试地址：hitpaw-test.afirstsoft.cn/in/...
    else if (
      /\.in/.test(hostname) ||
      (isDEV_NODE_ENV && /(\/in\/)/.test(pathname))
    ) {
      lang = 'in';
    }
    // 正式地址：online.hitpaw.id ||  测试地址：hitpaw-test.afirstsoft.cn/id/...
    else if (
      /\.id/.test(hostname) ||
      (isDEV_NODE_ENV && /(\/id\/)/.test(pathname))
    ) {
      lang = 'id';
    }
    // 正式地址：online.hitpaw.nl ||  测试地址：hitpaw-test.afirstsoft.cn/tr/...
    else if (
      /\.nl/.test(hostname) ||
      (isDEV_NODE_ENV && /(\/nl\/)/.test(pathname))
    ) {
      lang = 'nl';
    } else {
      lang = 'en';
    }

    console.log('lang', lang);
    return lang;
  },
};

export default utils;
